//#Global Imports
import React from "react";
//#end Global Imports

//#Local Imports
import { CircleXCloseMark, RefreshIcon, SearchIcon } from "../../assets/Icons";
import Button from "../../components/ui/Button";
import TextField from "../../components/ui/TextField";
import Typograpy from "../../components/ui/Typography";
import { IRemitterProps } from "./Remmiter";
import { Mixpanel } from "../../constants/mixpanel";
import RemitterIconNew from "../../assets/Icons/RemitterIconNew";
import RotateIcon from "../../assets/Icons/Rotate";
//#end Local Imports

const RemitterNavbar: React.FC<IRemitterProps.INavbarProps> = ({
  setAddRemitterModal,
  setSearchedInput,
  searchedInput,
  handleRefresh,
}) => {
  return (
    <div className="flex flex-col gap-8 mt-10 ml-[18px] mr-[52px] mb-8">
      <div className="flex items-center gap-3 mr-16">
        <RemitterIconNew />
        <Typograpy tagType="div" text="Remitter" className="font-bold text-2xl text-black font-roboto" />
      </div>
      <div className="flex items-center justify-between w-full">
        <div className="w-[427px] mr-28">
          <TextField
            name="searchValue"
            type="text"
            placeholder={
              searchedInput ? (
                <div className="flex items-center w-full justify-between">
                  <div className=" cursor-pointer" onClick={() => {
                    setSearchedInput("")
                  }}>
                    <CircleXCloseMark />
                  </div>
                </div>
              ) : (
                <div className="flex items-center gap-2 w-full">
                  <SearchIcon fillColor="fill-grey-1550" />
                  <span>Search by Name/Number/Email</span>
                </div>
              )
            }
            value={searchedInput}
            fullWidth
            inputClasses="bg-white-200 !border-none !rounded-[145px] !pt-2"
            placeholderStyle={searchedInput ? "!top-[1.5rem] !left-[79%] text-grey-1550 font-normal text-sm" : "text-grey-1550 font-normal text-sm !right-1/4 w-[90%]"}
            onChange={(e) => {
              setSearchedInput(e.target.value);
            }}
            pattern="[a-zA-Z0-9 ]{1,}"
          />
        </div>
        <div className="flex items-center gap-8">
          <div className="">
            <Button
              bgColor="bg-[#006EFF]"
              fontStyle={{
                fontFamily: "font-Inter",
                fontSize: "text-base",
                fontWeight: "font-semibold",
                fontColor: "text-white",
              }}
              borderStyle={{
                borderRadius: "rounded-lg",
              }}
              className="w-52 add-remitter-button py-4 px-6"
              onClickHandler={() => {
                setAddRemitterModal(true);
                Mixpanel.track("Add_New _Remitter");
              }}
            >
              ADD NEW REMITTER
            </Button>
          </div>
          <Button
            bgColor="bg-transparent"
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-base",
              fontWeight: "font-semibold",
              fontColor: "text-black",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            className="add-remitter-button items-end space-x-4 justify-end"
            onClickHandler={handleRefresh}
          >
            {/* <RefreshIcon fillColor="blue" width={"40px"} height="40px" /> */}
            <RotateIcon />
            {/* <span className="">Refresh</span> */}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RemitterNavbar;
